module.exports = __webpack_public_path__ + "static/media/headset-black.01fac197.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/headset-black.svg
// module id = 58
// module chunks = 0